'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttleDecorator;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throttleDecorator(resolver) {
  var inFlight = false;

  return function () {
    if (inFlight) return _q2.default.defer().promise;

    inFlight = true;

    var promise = resolver.apply(undefined, arguments);
    promise.finally(function () {
      return inFlight = false;
    });
    return promise;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/decorators/throttleDecorator.js
// module id = 459
// module chunks = 0